module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-row', [_c('v-col', [_c('div', {
    staticClass: "box-header"
  }, [(_vm.buttonShow('create', _vm.currentUserRole)) ? _c('v-btn', {
    staticClass: "secondary",
    on: {
      "click": function($event) {
        return _vm.create()
      }
    }
  }, [_vm._v("\n          Create new\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('v-card', [_c('v-card-text', [_c('v-layout', {
    staticStyle: {
      "justify-content": "right"
    },
    attrs: {
      "wrap": "",
      "mb-2": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": "",
      "pr-3": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "item-value": "id",
      "item-text": "name",
      "items": _vm.userRoleOptions,
      "label": "Role Filter",
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "auto-select-first": ""
    },
    on: {
      "change": function($event) {
        return _vm.paginate(1)
      }
    },
    model: {
      value: (_vm.filters.role),
      callback: function($$v) {
        _vm.$set(_vm.filters, "role", $$v)
      },
      expression: "filters.role"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pt-0",
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.paginate(1)
      }
    },
    model: {
      value: (_vm.filters.keyword),
      callback: function($$v) {
        _vm.$set(_vm.filters, "keyword", $$v)
      },
      expression: "filters.keyword"
    }
  })], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.fields,
      "items": _vm.items,
      "options": _vm.pagination,
      "server-items-length": _vm.totalRows
    },
    on: {
      "update:options": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(ref) {
        var items = ref.items;

        return [_c('tbody', _vm._l((items), function(item) {
          return _c('tr', {
            key: item.id
          }, [_c('td', [_vm._v(_vm._s(item.firstName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.lastName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roleDisplay(item.role)))]), _vm._v(" "), _c('td', [(_vm.buttonShow('delete', item.role)) ? _c('v-btn', {
            staticClass: "ims-action",
            attrs: {
              "color": "red",
              "small": ""
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.deleteUser(item)
              }
            }
          }, [_c('v-icon', _vm._g({
            staticStyle: {
              "color": "#fff"
            },
            attrs: {
              "small": ""
            }
          }, _vm.on), [_vm._v("mdi-delete")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('update', item.role)) ? _c('v-btn', {
            staticClass: "ims-action primary",
            attrs: {
              "small": "",
              "data-toggle": "modal",
              "data-target": _vm.editModalIdDisplay
            },
            on: {
              "click": function($event) {
                return _vm.getUserDataToEdit(item.id)
              }
            }
          }, [_c('v-icon', _vm._g({
            attrs: {
              "small": ""
            }
          }, _vm.on), [_vm._v("mdi-account-edit")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('view', item.role)) ? _c('v-btn', {
            staticClass: "ims-action",
            attrs: {
              "small": "",
              "color": "info",
              "data-toggle": "modal",
              "data-target": _vm.viewModalIdDisplay
            },
            on: {
              "click": function($event) {
                return _vm.getUserDataToView(item.id)
              }
            }
          }, [_c('v-icon', _vm._g({
            staticStyle: {
              "color": "#fff"
            },
            attrs: {
              "small": ""
            }
          }, _vm.on), [_vm._v("mdi-eye")])], 1) : _vm._e(), _vm._v(" "), (_vm.buttonShow('confirmUser', item.role)) ? _c('v-btn', {
            staticClass: "ims-action",
            attrs: {
              "small": "",
              "color": "info",
              "data-toggle": "modal",
              "data-target": _vm.confirmUserModalIdDisplay
            },
            on: {
              "click": function($event) {
                return _vm.getUserDataToEdit(item.id)
              }
            }
          }, [_c('v-icon', _vm._g({
            staticStyle: {
              "color": "#fff"
            },
            attrs: {
              "small": ""
            }
          }, _vm.on), [_vm._v("mdi-check")])], 1) : _vm._e()], 1)])
        }), 0)]
      }
    }])
  })], 1)], 1)], 1)])], 1), _vm._v(" "), _c('create-user-modal', {
    on: {
      "createUser": _vm.createUser
    },
    model: {
      value: (_vm.createUserModalDialog),
      callback: function($$v) {
        _vm.createUserModalDialog = $$v
      },
      expression: "createUserModalDialog"
    }
  }), _vm._v(" "), _c('edit-user-modal', {
    attrs: {
      "modalId": _vm.editModalId,
      "userData": _vm.editUserData
    },
    on: {
      "editUser": _vm.editUser
    }
  }), _vm._v(" "), _c('view-user-modal', {
    attrs: {
      "modalId": _vm.viewModalId,
      "userData": _vm.viewUserData
    }
  }), _vm._v(" "), _c('assign-user-to-client-modal', {
    attrs: {
      "modalId": _vm.assignUserToClientModalId,
      "userData": _vm.viewUserData
    }
  }), _vm._v(" "), _c('confirm-user-modal', {
    attrs: {
      "modalId": _vm.confirmUserModalId,
      "userData": _vm.editUserData
    },
    on: {
      "editUser": _vm.editUser
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8779c2de"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/User/index.vue
// module id = 2231
// module chunks = 0